import { RootState } from 'redux/type';

// MODEL
import { Contact } from 'model';

// INITIAL STATE
import { initialSingleContact } from './slice';

export const selectContactLoadingStatus = (state: RootState): boolean => state.contactReducer.loading;
export const selectContact = (state: RootState): Contact => state.contactReducer.single || initialSingleContact;
export const selectManyContacts = (state: RootState): Contact[] => state.contactReducer.many || [];
